import { createAction } from '@reduxjs/toolkit';

const clearAuthenticatedState = createAction('auth/clearAuthenticatedState');

export default clearAuthenticatedState;
